module.exports = __webpack_public_path__ + "static/media/four.bfda25ed.jpg";